import Component from './review-form';
export default Component;
